(function () {
  // Each $0 "Free Hat - With Purchase" variant maps to a real hat product variant.
  // realVariantId is stored as a line property so Shopify Flow can decrement the right inventory.
  var HATS = [
    {
      variantId: 56674090811558,
      realVariantId: '43220136951974',
      name: 'Red Kona Trucker Cap',
      image: 'https://cdn.shopify.com/s/files/1/0617/8429/3542/files/103.png?v=1770229218'
    },
    {
      variantId: 56674090844326,
      realVariantId: '43220136984742',
      name: 'Tropic Water Blue Leather Patch Trucker Cap',
      image: 'https://cdn.shopify.com/s/files/1/0617/8429/3542/files/108.png?v=1770229170'
    },
    {
      variantId: 56674090877094,
      realVariantId: '45919406358694',
      name: 'Corduroy Brown Kona Cap',
      image: 'https://cdn.shopify.com/s/files/1/0617/8429/3542/files/114.png?v=1770222170'
    },
    {
      variantId: 56674090909862,
      realVariantId: '45919409471654',
      name: 'Corduroy Pink Kona Cap',
      image: 'https://cdn.shopify.com/s/files/1/0617/8429/3542/files/120.png?v=1770222116'
    }
  ];

  var previousFlannelCount = null;

  // ── Helpers ────────────────────────────────────────────────────────────

  function getUpsellBar() {
    return document.querySelector('.flannel-hat-upsell');
  }

  function getModal() {
    return document.getElementById('flannel-hat-modal');
  }

  function getUpsellData() {
    var bar = getUpsellBar();
    if (!bar) return { flannelCount: 0, hasFreeHat: false, freeHatKey: '' };
    return {
      flannelCount: parseInt(bar.dataset.flannelCount || '0', 10),
      hasFreeHat: bar.dataset.hasFreeHat === 'true',
      freeHatKey: bar.dataset.freeHatKey || ''
    };
  }

  // ── Modal ──────────────────────────────────────────────────────────────

  function buildModalOptions() {
    var container = document.querySelector('.flannel-hat-modal__options');
    if (!container) return;
    container.innerHTML = HATS.map(function (hat) {
      return '<button'
        + ' class="flannel-hat-modal__option js-flannel-hat-option"'
        + ' data-variant-id="' + hat.variantId + '"'
        + ' data-real-variant-id="' + hat.realVariantId + '"'
        + ' data-hat-name="' + hat.name.replace(/"/g, '&quot;') + '"'
        + ' type="button">'
        + '<img src="' + hat.image + '" alt="' + hat.name + '" loading="lazy" width="200" height="200">'
        + '<div class="flannel-hat-modal__option-name">' + hat.name + '</div>'
        + '</button>';
    }).join('');
  }

  function openModal() {
    buildModalOptions();
    var modal = getModal();
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    var panel = modal.querySelector('.flannel-hat-modal__panel');
    if (panel) panel.focus();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
  }

  // ── State evaluation — runs after every cart merge ─────────────────────

  function evaluateState() {
    var data = getUpsellData();

    // Auto-remove hat if customer dropped below 2 flannels
    if (data.flannelCount < 2 && data.hasFreeHat && data.freeHatKey) {
      previousFlannelCount = data.flannelCount;
      removeFreeHat(data.freeHatKey);
      return;
    }

    // Auto-open modal when flannel count crosses the threshold
    if (data.flannelCount >= 2 && !data.hasFreeHat) {
      if (previousFlannelCount !== null && previousFlannelCount < 2) {
        setTimeout(openModal, 350);
      }
    }

    previousFlannelCount = data.flannelCount;
  }

  // ── Cart API ──────────────────────────────────────────────────────────────

  function triggerThemeRefresh() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
  }

  function addHatToCart(variantId, realVariantId, hatName) {
    var modal = getModal();
    var btn = modal && modal.querySelector('[data-variant-id="' + variantId + '"]');
    if (btn) btn.disabled = true;

    previousFlannelCount = getUpsellData().flannelCount;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _free_hat: 'true',
          _hat_real_variant_id: realVariantId,
          _hat_name: hatName
        }
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Cart add failed: ' + res.status); });
        closeModal();
        triggerThemeRefresh();
      })
      .catch(function (e) {
        console.error('[Flannel Hat Upsell] Failed to add hat:', e);
        if (btn) btn.disabled = false;
      });
  }

  function removeFreeHat(lineKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () { triggerThemeRefresh(); })
      .catch(function (e) { console.error('[Flannel Hat Upsell] Failed to remove hat:', e); });
  }

  // ── Inject modal shell & styles ───────────────────────────────────────────

  function injectModal() {
    if (document.getElementById('flannel-hat-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'flannel-hat-modal';
    modal.className = 'flannel-hat-modal';
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-labelledby', 'flannel-hat-modal-title');
    modal.innerHTML =
      '<div class="flannel-hat-modal__overlay js-flannel-hat-modal-close"></div>'
      + '<div class="flannel-hat-modal__panel" tabindex="-1">'
      + '<button class="flannel-hat-modal__close js-flannel-hat-modal-close" type="button" aria-label="Close">&#x2715;</button>'
      + '<p class="flannel-hat-modal__title" id="flannel-hat-modal-title">Choose Your Free Hat</p>'
      + '<p class="flannel-hat-modal__subtitle">Pick any hat &mdash; it&rsquo;s on us!</p>'
      + '<div class="flannel-hat-modal__options"></div>'
      + '</div>';
    document.body.appendChild(modal);
  }

  function injectStyles() {
    if (document.getElementById('flannel-hat-upsell-styles')) return;
    var style = document.createElement('style');
    style.id = 'flannel-hat-upsell-styles';
    style.textContent = [
      /* Upsell bar */
      '.flannel-hat-upsell{padding:10px 0 4px}',
      '.flannel-hat-upsell__steps{display:flex;gap:6px;margin-bottom:8px}',
      '.flannel-hat-upsell__step{flex:1;height:5px;border-radius:3px;background:rgba(0,0,0,.12);transition:background .35s}',
      '.flannel-hat-upsell__step--filled{background:currentColor}',
      '.flannel-hat-upsell__message{font-size:.83em;line-height:1.4}',
      '.flannel-hat-upsell__msg--complete{font-weight:600}',
      '.flannel-hat-upsell__msg--ready{font-weight:500}',
      '.flannel-hat-upsell__cta{display:inline-block;background:currentColor;border:none;padding:3px 10px;border-radius:3px;cursor:pointer;font-size:.9em;font-weight:600;margin-left:4px;vertical-align:middle;color:var(--bg,#fff)}',
      /* FREE badge on cart line item */
      '.cart-item__selling-price--free{font-weight:700;letter-spacing:.06em;font-size:.9em;color:currentColor}',
      /* Modal */
      '.flannel-hat-modal{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center}',
      '.flannel-hat-modal[hidden]{display:none}',
      '.flannel-hat-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.5);cursor:pointer}',
      '.flannel-hat-modal__panel{position:relative;background:var(--bg,#fff);color:var(--text-color,#111);border-radius:12px;padding:28px 24px 24px;max-width:480px;width:calc(100% - 32px);max-height:90vh;overflow-y:auto;z-index:1;outline:none}',
      '.flannel-hat-modal__title{font-size:1.2em;font-weight:700;margin:0 0 4px}',
      '.flannel-hat-modal__subtitle{font-size:.9em;opacity:.65;margin:0 0 20px}',
      '.flannel-hat-modal__close{position:absolute;top:14px;right:14px;background:none;border:none;cursor:pointer;padding:4px 6px;font-size:1.1em;line-height:1;opacity:.6}',
      '.flannel-hat-modal__close:hover{opacity:1}',
      '.flannel-hat-modal__options{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
      '.flannel-hat-modal__option{border:2px solid rgba(0,0,0,.1);border-radius:8px;overflow:hidden;cursor:pointer;background:none;padding:0;text-align:left;transition:border-color .2s,transform .15s,box-shadow .2s}',
      '.flannel-hat-modal__option:hover{border-color:currentColor;transform:translateY(-2px);box-shadow:0 4px 12px rgba(0,0,0,.12)}',
      '.flannel-hat-modal__option img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block}',
      '.flannel-hat-modal__option-name{padding:8px 10px;font-size:.78em;font-weight:500;line-height:1.3}'
    ].join(' ');
    document.head.appendChild(style);
  }

  // ── Events ────────────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-flannel-hat-cta')) {
      openModal();
    } else if (e.target.closest('.js-flannel-hat-modal-close')) {
      closeModal();
    } else if (e.target.closest('.js-flannel-hat-option')) {
      var btn = e.target.closest('.js-flannel-hat-option');
      addHatToCart(
        parseInt(btn.dataset.variantId, 10),
        btn.dataset.realVariantId,
        btn.dataset.hatName
      );
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('on:cart:after-merge', evaluateState);

  // ── Init ─────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    injectModal();
    previousFlannelCount = getUpsellData().flannelCount;
    var data = getUpsellData();
    if (data.flannelCount < 2 && data.hasFreeHat && data.freeHatKey) {
      removeFreeHat(data.freeHatKey);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
